import { api } from '@/api/client';

/**
 * A systeem code as Odoo defines it. Not a union: the price grid follows the
 * "Plaatsing onderaannemers" variants, so giving a new system variants in Odoo makes
 * its rows appear here without a code change (see stores/systems).
 */
export type PriceSysteem = string;
export type PriceTier = 'under200' | 'from200';

/** One placement variant (systeem × legpatroon) with its two tier prices for a vendor. */
export interface VendorPriceRow {
  productId: number;
  systeem: PriceSysteem;
  legpatroon: number;
  label: string;
  priceUnder200: number | null;
  priceFrom200: number | null;
  idUnder200: number | null;
  idFrom200: number | null;
}

export interface VendorPrices {
  vendorId: number;
  vendorName: string;
  rows: VendorPriceRow[];
}

export interface VendorPricesResponse {
  vendors: VendorPrices[];
}

export interface CreatePricePayload {
  vendorId: number;
  productId: number;
  tier: PriceTier;
  price: number;
}

export async function fetchVendorPrices(): Promise<VendorPricesResponse> {
  return api<VendorPricesResponse>('/api/onderaannemers/prices');
}

export async function createVendorPrice(payload: CreatePricePayload): Promise<{ id: number }> {
  return api<{ id: number }>('/api/onderaannemers/prices', {
    method: 'POST',
    body: JSON.stringify({
      vendorId: payload.vendorId,
      productId: payload.productId,
      tier: payload.tier,
      price: payload.price,
    }),
  });
}

export async function updateVendorPrice(id: number, price: number): Promise<{ id: number }> {
  return api<{ id: number }>(`/api/onderaannemers/prices/${id}`, {
    method: 'PATCH',
    body: JSON.stringify({ price }),
  });
}

export async function deleteVendorPrice(id: number): Promise<{ id: number }> {
  return api<{ id: number }>(`/api/onderaannemers/prices/${id}`, {
    method: 'DELETE',
  });
}
